import { Button, ButtonType } from "components/Button/Button";
import { formatDate } from "utils/formatting";
import './CourseEditControls.scss';

const CourseEditControls = ({ locked, data, handleLockToggle, canPreview, handlePreviewCourseClick }) => {
	return (
		<>
			<div className="course-editor-controls">
				<h1>Course Controls</h1>
				{locked.hasTimestamp ? (
					locked.byCurrentUser ? (
						<p>
							You are currently editing this course. It is locked for other users until you
							press the button below or until it times out after a period of inactivity.
						</p>
					) : (
						<p>
							Course locked by {data.LockUsername} at{" "}
							{formatDate(data.LockTimestamp, true)}
						</p>
					)
				) : (
						<p>When you are editing, the course will be locked for other users.</p>
				)}
				<div className="course-editor-controls-buttons">
					<Button
						text={locked.hasTimestamp ? "End Editing" : "Start Editing"}
						disabled={locked.hasTimestamp && !locked.byCurrentUser}
						onClick={handleLockToggle}
					/>

					<Button
						type={ButtonType.Secondary}
						text="Preview"
						onClick={handlePreviewCourseClick}
						disabled={!canPreview} />
				</div>
			</div>

		</>
	);
};

export default CourseEditControls;
